<template>
  <div :class="cls">
    <a v-if="iosShow" :href="iosLink" @click="recordIosTrack">{{text}}</a>
    <span v-else @click="toDownloadPage">{{text}}</span>
  </div>
</template>


<script>
  import querystring from 'query-string'
  import cookie from 'js-cookie'
  import { ios, weixin } from '@beastshop/browser'
  import { atob, btoa } from 'b2a'
  import track from '@/track'

  const PROTOCOL = location.protocol
  const IOS_LINK = `${PROTOCOL}//a.app.qq.com/o/simple.jsp?pkgname=com.thebeastshop.thebeast`
  const TD_PREFIX = `${PROTOCOL}//lnk0.com/`
  const IOS_STORE_LINK = `https://apps.apple.com/cn/app/1147017306`

  const hostname = location.hostname
  const search = location.search.slice(1)
  const urlParams = querystring.parse(search)
  const tdMap = {
    'index': {
      'i': 'JxdoMh',
      'a': '1UNxBd',
    },
    'article': {
      'i': 'JZN9k4',
      'a': 'wpE5ss',
    },
    'story': {
      'i': 'c8ABVd',
      'a': 'J5gU9g',
    },
    'list': {
      'i': 'wNV9At',
      'a': 'dE5IZt',
    },
    'product': {
      'i': '10UtQd',
      'a': 'xJFBxt',
    },
  }
  // const dParam = urlParams._d
  let iParam = urlParams._i || cookie.get('_b_i')
  let aParam = urlParams._a || cookie.get('_b_a')

  export default {
    name: 'open-app',
    props: {
      cls: {
        type: String,
        default: 'open-app-area',
      },
      text: {
        type: String,
        default: '打开APP'
      },
      link: {
        type: String,
        default: '',
      },
      talkingData: {
        type: Object,
        default: null
      },
      pageType: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        formatLink: null
      }
    },
    computed: {
      iosShow () {
        if(ios()) {
          return true
        } else {
          return false
        }
      },
      iosLink () {
        // const il = iParam?`${TD_PREFIX}${iParam}`:IOS_LINK
        // const il = iParam
        //   // ? weixin()?IOS_LINK:`${TD_PREFIX}${iParam}`
        //   ? weixin()?IOS_LINK:IOS_STORE_LINK
        //   : IOS_LINK //微信无法打开我们的appstore短链 所以微信浏览器里面打开应用宝 这样会丢失一部分短链打点
        const il = weixin()?IOS_LINK:IOS_STORE_LINK
        return `${PROTOCOL}//${process.env.AUL_DOMAIN}/r?r=${btoa(il)}&_d=${btoa(this.formatLink)}`
        // return `beastapp://${this.formatLink}`
      }
    },
    created () {
      if(!iParam) {
        iParam = tdMap[this.pageType]?tdMap[this.pageType]['i']:''
      }
      if(!aParam) {
        aParam = tdMap[this.pageType]?tdMap[this.pageType]['a']:''
      }
      this.initLink()
    },
    methods: {
      initLink () {
        if(!iParam && this.talkingData) {
          iParam = this.talkingData._i
        }
        if(!aParam && this.talkingData) {
          aParam = this.talkingData._a
        }
        let link = this.link
        let redirectLink = ""
        if(!link) {
          if(iParam || aParam) {
            redirectLink = `index?_i=${iParam}&_a=${aParam}`
          } else {
            redirectLink = `index`
          }
        } else {
          let index = link.indexOf("?")
          if(iParam || aParam) {
            if(index !== -1) {
              if(link.indexOf("_i=") !== -1 || link.indexOf("_a=") !== -1) {
                redirectLink = link
              } else {
                redirectLink = `${link}&_i=${iParam}&_a=${aParam}`
              }
            } else {
              redirectLink = `${link}?_i=${iParam}&_a=${aParam}`
            }
          } else {
            redirectLink = link
          }
        }
        this.formatLink = redirectLink
      },
      recordIosTrack () {
        this.trackData('ios')
      },
      toDownloadPage () {
        this.trackData('android')

        setTimeout(() => {
          window.location.href=`https://m.thebeastshop.com/dl?_d=${btoa(this.formatLink)}&_i=${iParam}&_a=${aParam}`
        }, 200)
      },
      trackData (devide) {
        let trackData = {
          name: 'download-banner',
          attrs: {
            pageType: this.pageType,
            device: devide
          },
          wait: false
        }
        console.log(trackData, "trackData")

        track(trackData)
      }
    },
  }
</script>

<style lang="stylus">
@import '../../common/styl/global.styl'
.open-app-area
  display inline-block
  height rem(34)
  line-height rem(34)
  padding 0 rem(12)
  background #000000
  border-radius rem(2)
  font-size rem(12)
  font-weight bold
  color #ffffff
  letter-spacing rem(1)

  a,span
    display inline-block
    width 100%
    height 100%
    color inherit
    text-decoration inherit


</style>



// WEBPACK FOOTER //
// index.vue?523494e9